import { Component, inject } from '@angular/core';
import { LoaderService } from '../../../../core/services/loader.service';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-horizinns-loader',
  imports: [
    CommonModule,
    MatProgressBarModule
  ],
  templateUrl: './horizinns-loader.html',
  styleUrl: './horizinns-loader.scss',
})
export class HorizinnsLoader {
  private loaderService = inject(LoaderService);

  /** * We link the component's isLoading property directly to the 
   * Service's read-only signal. This ensures the UI stays 
   * perfectly in sync with network requests.
   */
  isLoading = this.loaderService.isLoading;
}
